// @flow
import * as React from 'react';
import type { Node } from 'react';

const ShaveLoader = () => import(/* webpackChunkName: "ShaveLibrary" */ 'shave');

type Props = {
  children: Node,
  maxHeightPx: number,
  maxWidthPx?: number,
  shaveOptions?: any,
  inline?: boolean,
};

type State = {|
  manualTruncate: boolean,
|};

/**
 * Truncates text rendered in children, uses shave.js API
 * https://dollarshaveclub.github.io/shave/
 * React-specific truncation libs currently lack support for nested/custom text styles + truncation
 */
class Truncater extends React.Component<Props, State> {
  /**
   * @param  {Props.maxHeightPx} maxHeight in px of desired text
   * @param  {Props.inline} option to render inline vs block
   * @param  {Props.shaveOptions} options to provide to the shave.js API
   */

  state = {
    manualTruncate: false,
  };

  // $FlowFixMe Flow v0.104.0 upgrade supression.
  ref: React.ElementRef<*>;

  constructor(props: Props) {
    super(props);
    // NOTE: Generate a random id for shave.js to hook onto
    this.ref = React.createRef();
  }

  componentDidMount() {
    // NOTE: Find the mounted id and truncate
    const { maxHeightPx, shaveOptions = {} } = this.props;

    const ref = this.ref && this.ref.current;

    if (!ref) {
      return;
    }

    const textProp = ref.textContent === undefined ? 'innerText' : 'textContent';

    const fullText = ref[textProp];
    const spaces = typeof shaveOptions.spaces === 'boolean' ? shaveOptions.spaces : true;
    const words = spaces ? fullText.split(' ') : fullText;

    // NOTE: shave will not truncate 0 or 1 word text, so we need to manually truncate these scenarios
    if (words.length < 2) {
      this.setState({ manualTruncate: true });
      return;
    }

    ShaveLoader().then(({ default: shave }) => {
      shave(ref, maxHeightPx, shaveOptions);
    });
  }

  render() {
    const { maxWidthPx, maxHeightPx, inline = false } = this.props;
    const { manualTruncate } = this.state;

    const baseStyle = { maxWidth: maxWidthPx, maxHeight: maxHeightPx };
    const style = inline ? { display: 'inline', ...baseStyle } : { ...baseStyle };

    if (manualTruncate) {
      return (
        <div ref={this.ref} style={{ ...style, overflow: 'hidden' }}>
          {this.props.children}
        </div>
      );
    }

    return (
      <div ref={this.ref} style={style}>
        {this.props.children}
      </div>
    );
  }
}

export default Truncater;
